<bs-betbuilder-pick-ui
    [isEpcotEnabled]="isEpcotEnabled"
    [isCombo]="isCombo"
    [headerTitle]="headerText"
    [date]="date"
    [selections]="selections | async"
    [isRemoveButtonVisible]="true"
    [provider]="pick.groupInfo.provider"
    [hasWarning]="hasWarning$ | async"
    [pick]="pick"
    (removeSelection)="removeBetBuilderSelection($event)">
</bs-betbuilder-pick-ui>
